module.exports = __webpack_public_path__ + "img/YFII.2bb6b532.svg";